import { render } from "./PdfDoc.vue?vue&type=template&id=1b5f966e&scoped=true"
import script from "./PdfDoc.vue?vue&type=script&lang=js"
export * from "./PdfDoc.vue?vue&type=script&lang=js"

import "./PdfDoc.vue?vue&type=style&index=0&id=1b5f966e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b5f966e"]])

export default __exports__